<template>
    <tbody :id="'tbody_type_' + type">
        <tr :id="'rowGroup_type_' + type" class="dtrg-group dtrg-start dtrg-level-0">
            <td colspan="7" class="text-capitalize">
                <div class="row">
                    <div class="col-sm-12 col-md-9">
                        <span class="text-secondary mr-2"><i class="fas" :class="getIcon(type)"></i></span>{{$t('salon_report.item_types.' + type)}}
                    </div>
                    <div v-if="Object.keys(groupItems).length != 0" class="col-sm-12 col-md-3 fs-xs fw-300 text-right">
                        <a class="btn btn-xs btn-outline-primary text-primary typeExpand" @click="showAllDetails(type, null)">{{isExpand == 'Expand' ? $t('button_link.expand_details') : $t('button_link.collapse_details')}}</a>
                    </div>
                </div>
            </td></tr>
        <tr v-if="Object.keys(groupItems).length == 0"><td class="text-secondary" colspan="7"><small>{{$t('label.no', {'item': $t('salon_report.item_types.' + type)})}}</small></td></tr>
        <tr v-for="(item, i, j) in groupItems" :key="i">
            <td class="align-middle text-center">{{j+1}}</td>
            <td class="align-middle">
                <a class="fw-500 text-primary link" :id="'item_' + i" @click="showDetails($event, type)">{{item[0].item.title}}</a>
                <div class="mt-1 detailTable" style="display: none;">
                     <table class="card-table table table-sm table-hover table-bordered table-striped">
                        <thead class="thead-themed">
                            <tr>
                                <th></th>
                                <th>{{$t('table.header.sales_redeem')}}</th>
                                <th>{{$t('table.header.effort')}}</th>
                                <th>{{$t('table.header.fee')}}</th>
                                <th>{{$t('table.header.quantity')}}</th>
                            </tr>
                        </thead>
                        <tr>
                            <th>{{$t('subMenu.salon_report_sales')}}</th>
                            <td>{{formatPrice(getSum(i).sales)}}</td>    
                            <td>{{formatPrice(getSum(i).salesEffort)}}</td>
                            <td>{{formatPrice(getSum(i).salesFee)}}</td>
                            <td>{{getSum(i).salesQty}}</td>
                        </tr>
                        <tr>
                            <th>{{$t('subMenu.salon_report_credit')}}</th>
                            <td>{{formatPrice(getSum(i).credits)}}</td>
                            <td>{{formatPrice(getSum(i).creditEffort)}}</td>
                            <td>{{formatPrice(getSum(i).creditFee)}}</td>
                            <td rowspan="2" class="align-middle">{{getSum(i).creditsQty + getSum(i).packagesQty}}</td>    
                        </tr>
                        <tr>
                            <th>{{$t('subMenu.salon_menu_package')}}</th>
                            <td>{{formatPrice(getSum(i).packages)}}</td>    
                            <td>{{formatPrice(getSum(i).packageEffort)}}</td>
                            <td>{{formatPrice(getSum(i).packageFee)}}</td>
                        </tr>
                    </table>    
                </div>
            </td>
            <td class="align-middle text-center" title="Total Quantity">{{objItem[i].salesQty + objItem[i].creditsQty + objItem[i].packagesQty}}</td>
            <td class="align-middle text-center" title="Total Effort">{{formatPrice(objItem[i].salesEffort + objItem[i].creditEffort + objItem[i].packageEffort)}}</td>
            <td class="align-middle text-center" title="Total Fee">{{formatPrice(objItem[i].salesFee + objItem[i].creditFee + objItem[i].packageFee)}}</td>
        </tr>
        <tr v-if="Object.keys(groupItems).length != 0">
            <td class="border-top-bottom-2 text-right fw-500" colspan="2">{{$t('label.total')}}</td>
            <td class="border-top-bottom-2 fw-500 text-center">{{total.total}}</td>
            <td class="border-top-bottom-2 fw-500 text-center">{{total.effort}}</td>
            <td class="border-top-bottom-2 fw-500 text-center">{{total.fee}}</td>
        </tr>
    </tbody>
</template>
<script>
import _ from 'lodash';
import {getIcon} from './../../../../assets/js/dashboard/dashboard'
import {calculateCategoryTotalRedeem} from './../../../../assets/js/dashboard/salonReport/salonReport'

export default {
    name:'commissionItemsTable',
    props:{ 
        items: { type: Array },
        type: { type: String },
        staffObj: { type: Object }
    },
    data(){
        return{
            objItem:{}, isExpand: "Expand", total: {}
        }
    },
    computed:{
        groupItems(){
            var ret = _.groupBy(this.items, 'item.itemID');
            return ret
        },
    },
    watch:{
        groupItems(value){
            this.setTotalEntries(Object.keys(value).length)
            this.setTotal(value)
        }
    },
    methods:{
        showDetails(e, type){
            var link = e.target.id;
            var detailsDiv = document.getElementById(link).nextSibling;
            detailsDiv.style.display = detailsDiv.style.display == 'none' ? 'block' : 'none';

            var hideCount = 0;
            var allRow = document.getElementById("tbody_type_" + type).querySelectorAll(".detailTable")

            for(var i=0; i<allRow.length; i++){
                if(allRow[i].style.display == 'none'){
                    hideCount++
                }
            }

            this.isExpand = hideCount == Object.keys(this.groupItems).length ? "Expand" : "Collapse"
            this.$emit('setExpandAll', this.isExpand)
        },
        showAllDetails(type, isExpandAll){
            var isExpand = false;
            if(this.isExpand == "Expand"){
                isExpand = true;
                this.isExpand = "Collapse"
            }else{
                isExpand = false;
                this.isExpand = "Expand"
            }
            var detailsContainer = document.getElementById("tbody_type_" + type).querySelectorAll(".detailTable");
            for(var i=0; i<detailsContainer.length; i++){
                if(isExpandAll != null){
                    if(isExpandAll){
                        if(detailsContainer[i].style.display == 'none'){
                            detailsContainer[i].style.display = 'block'
                        }
                        this.isExpand = "Collapse";
                    }else{
                        if(detailsContainer[i].style.display == 'block'){
                            detailsContainer[i].style.display = 'none'
                        }
                        this.isExpand = "Expand";
                    }
                }else{
                    if(isExpand){
                        if(detailsContainer[i].style.display == 'none'){
                            detailsContainer[i].style.display = 'block'
                        }
                    }else{
                        if(detailsContainer[i].style.display == 'block'){
                            detailsContainer[i].style.display = 'none'
                        }
                    }
                }
            }
            this.$emit('setExpandAll', this.isExpand)
        },
        formatPrice(p){
            return parseFloat(p).toFixed(2);
        },
        getIcon(type){
            return getIcon(type)
        },
        getSum(itemID){
            var items = {
                sales: 0, salesEffort: 0, salesFee: 0, salesQty: 0,
                credits: 0, creditEffort: 0, creditFee: 0, creditsQty: 0,
                packages: 0, packageEffort: 0, packageFee: 0, packagesQty: 0,
                fee: 0
            }; 

            var groupItem = this.groupItems[itemID]
            for(var i=0; i<groupItem.length; i++){
                items = calculateCategoryTotalRedeem(this.staffObj.staffID, groupItem[i].redeem, groupItem[i].price, groupItem[i].discount, groupItem[i].outstandings, groupItem[i].staffs, items) 
            }

        
            this.objItem[itemID] = items;
            return items;
        },
        setTotalEntries(len){
            this.$emit('setTotalEntries', len)
        },
       setTotal(items){
            var totalQty = 0
            var totalEffort = 0
            var totalFee = 0
            for(var k in items){
                totalQty += items[k].length
                var item = this.getSum(k)
                totalEffort += (item.salesEffort + item.creditEffort + item.packageEffort)
                totalFee += (item.salesFee + item.creditFee + item.packageFee)
            }
            this.total = {
                total: totalQty, 
                effort: parseFloat(totalEffort).toFixed(2),
                fee: parseFloat(totalFee).toFixed(2)
            }
           
       }
    }
}
</script>
<style scoped>
.link{
    cursor: pointer;
}

.card-table tr:nth-of-type(odd)>td:first-child{
    background: #ccbfdf;
    color: #fff;
}

.card-table tr>td:first-child{
    font-weight: 400;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>